import classnames from 'classnames';
import _ from 'lodash';
import React, {Component} from 'react';
import {
  resetManualWeatherData,
  resetManualWeatherDataSingleVariable,
  setManualWeatherData,
  setManualWeatherDataSingleVariable
} from '../actions';
import {PREFIX_RH, PREFIX_T} from '../utils/behaviour_models/shared/behaviour_models_utils';

class ManualWeatherForm extends Component {
  constructor(props) {
    super(props);

    // Local state separate from app state to support edit form.
    this.state = {
      form_open: false,
      variables: { ...props.data },
      original_values: { ...props.data },
      errors: {},
      pulsate_errors: false,
      resettable: false
    };

    this.handleNumberInputChange = this.handleNumberInputChange.bind(this);
    this.handleOpenForm = this.handleOpenForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.resetVariables = this.resetVariables.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleOpenForm() {
    this.setState({ form_open: true });
    this.resetVariables();
    // We want this one to propogate up so that the row becomes selected.
  }

  handleNumberInputChange(event) {
    const target = event.target;
    this.setState((state) => {
      const new_vars = { ...state.variables };
      new_vars[target.name] = Number(target.value);
      return { variables: new_vars };
    });
    this.setState((state, props) => {
      const new_errors = { ...state.errors };
      const meta = props.meta_data.find((e) => e.key === target.name);
      if (target.value < meta.min) {
        new_errors[target.name] = 'Min: ' + meta.min;
      } else if (target.value > meta.max) {
        new_errors[target.name] = 'Max: ' + meta.max;
      } else {
        new_errors[target.name] = '';
      }

      return { errors: new_errors };
    });
  }

  // Since the form is technically inside the row, we want to stop form clicks from propagating to the row click
  // handler.
  eatClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  handleCancel(event) {
    this.setState({ form_open: false });
    this.resetVariables();
    event.preventDefault();
    event.stopPropagation();
  }

  handleSubmit(event) {
    const { single_variable, meta_data, data, storageRow, dispatch } = this.props;
    const { variables } = this.state;

    if (_.some(_.values(this.state.errors), (e) => !!e)) {
      this.setState({ pulsate_errors: true });
      setTimeout(() => {this.setState({ pulsate_errors: false });}, 2000);
    } else {
      if (single_variable) {
        if (storageRow && (single_variable === PREFIX_T || single_variable === PREFIX_RH)) {
          dispatch(setManualWeatherData(meta_data, storageRow, variables));
        } else {
          dispatch(setManualWeatherDataSingleVariable(single_variable, variables));
        }
      } else if (storageRow) {
        const trMeta = meta_data.filter(m => m.editable && (m.key === PREFIX_T || m.key === PREFIX_RH));
        const otherMeta = meta_data.filter(m => m.editable && m.key !== PREFIX_T && m.key !== PREFIX_RH);
        if (trMeta.length > 0) {
          dispatch(setManualWeatherData(trMeta, storageRow, variables));
        }
        if (otherMeta.length > 0) {
          dispatch(setManualWeatherData(otherMeta, data, variables));
        }
      } else {
        dispatch(setManualWeatherData(meta_data, data, variables));
      }
      this.setState({ form_open: false });
    }
    event.preventDefault();
    event.stopPropagation();
  }

  handleReset(event) {
    const { single_variable, data, storageRow, dispatch } = this.props;
    if (single_variable) {
      dispatch(resetManualWeatherDataSingleVariable(single_variable));
    } else if (storageRow) {
      dispatch(resetManualWeatherData(storageRow));
      if (data.name !== storageRow.name) {
        dispatch(resetManualWeatherData(data));
      }
    } else {
      dispatch(resetManualWeatherData(data));
    }
    this.setState({ form_open: false });
    event.preventDefault();
    event.stopPropagation();
  }

  resetVariables() {
    const { modifications } = this.props;
    const variables = { ...this.props.data };
    const original_values = { ...this.props.data };
    let resettable = false;
    _.forOwn(variables, (value, key) => {
      if (modifications && typeof modifications[key] !== 'undefined') {
        variables[key] = modifications[key];
        resettable = true;
      }
    });

    this.setState({ variables, original_values, resettable });
  }

  handleKeyDown(event) {
    // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.handleSubmit(event);
    }
  }

  render() {
    const local = this.state.variables;
    const { form_open, errors, pulsate_errors, resettable, original_values } = this.state;
    const { meta_data, single_variable } = this.props;

    return <span className="c-form__manual-weather-panel">
      <span className="edit-action" onClick={this.handleOpenForm} title="Edit"><i className="fa fa-edit"/></span>

      {form_open &&
       <div className="c-form__variables-form-holder">
         <div className="c-form__variables-form" onClick={this.eatClick}>
           {!single_variable && <div>
             <label>Change from: </label>
             {local.name}
           </div>}
           {!single_variable && <div className="hr"/>}
           {meta_data.filter(m => m.editable).filter(m => !single_variable || m.key === single_variable).map(m =>
             <div key={m.key} className={original_values[m.key] === local[m.key] ? '' : 'modified'}>
               <label>{m.displayName}: </label>
               <input name={m.key} type="number" value={local[m.key]}
                      onChange={this.handleNumberInputChange} onKeyDown={this.handleKeyDown}/>
               {errors[m.key] &&
                <span className={classnames('c-form__error-messsage',
                  pulsate_errors ? ' pulsate' : '')}>{errors[m.key]}</span>
               }
             </div>
           )}
           <div className="c-form__buttons">
             {resettable &&
              <a className="c-form__reset-button" onClick={this.handleReset}>
                <i className="fa fa-undo"/><span>Reset</span>
              </a>
             }
             <a className="c-form__cancel-button" onClick={this.handleCancel}>
               <i className="fa fa-times-circle"/><span>Cancel</span>
             </a>
             <a className="c-button c-form__submit-button" onClick={this.handleSubmit}>
               <i className="fa fa-check-square"/><span>Submit</span>
             </a>
           </div>
         </div>
       </div>
      }
    </span>;
  }
}

export default ManualWeatherForm;



// WEBPACK FOOTER //
// ./src/components/ManualWeatherForm.js